/* Klout — Catálogo: facetas en vivo (Section Rendering API), sheet de filtros,
   cargar más y quick-add al carrito. Sin librerías. Mejora progresiva:
   sin JS, los filtros son enlaces normales y "Cargar más" pagina. */
(function () {
  'use strict';

  class KloutFacets extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.results = this.querySelector('#kcolResults');
      this._busy = false;

      // Abrir / cerrar el panel de filtros
      this.addEventListener('click', (e) => {
        var ob = e.target.closest('[data-kcol-open]');
        if (ob) { this.openSheet(ob.getAttribute('data-kcol-mode') || ''); return; }
        if (e.target.closest('[data-kcol-close]')) { this.closeSheet(); return; }

        // Navegación de facetas (opciones, chips de aplicados, limpiar, cargar más)
        var lm = e.target.closest('[data-kcol-loadmore]');
        if (lm) { e.preventDefault(); this.loadMore(lm); return; }
        // Orden (opciones tipo radio dentro del panel) — preserva filtros activos
        var so = e.target.closest('[data-kcol-sortopt]');
        if (so) {
          e.preventDefault();
          // Optimista: marca la opción elegida AL INSTANTE (los resultados cargan en fondo).
          this.querySelectorAll('[data-kcol-sortopt]').forEach(function (o) { o.classList.remove('on'); });
          so.classList.add('on');
          var su = new URL(window.location.href);
          su.searchParams.set('sort_by', so.dataset.sort);
          su.searchParams.delete('page');
          this.navigate(su.toString());
          return;
        }
        var nav = e.target.closest('[data-kcol-nav]');
        if (nav && nav.getAttribute('href')) {
          e.preventDefault();
          // Optimista: si es una opción de filtro (casilla), alterna su estado ya.
          if (nav.classList.contains('kcol__fopt')) nav.classList.toggle('on');
          this.navigate(nav.getAttribute('href'));
          return;
        }
      });

      // Rango de precio (form)
      this.addEventListener('submit', (e) => {
        var form = e.target.closest('[data-kcol-price]');
        if (!form) return;
        e.preventDefault();
        var u = new URL(window.location.href);
        u.searchParams.delete('page');
        Array.prototype.forEach.call(form.elements, function (el) {
          if (!el.name) return;
          // Limpia separadores de miles/espacios y normaliza coma decimal
          var val = (el.value || '').replace(/\s/g, '').replace(/,(?=\d{3}\b)/g, '').replace(',', '.');
          if (val) u.searchParams.set(el.name, val);
          else u.searchParams.delete(el.name);
        });
        this.navigate(u.toString());
      });

      // Quick-add (delegado en grid)
      this.addEventListener('click', (e) => {
        var btn = e.target.closest('button.kcard__qadd[data-kqa]');
        if (btn) { e.preventDefault(); this.quickAdd(btn); }
      });

      window.addEventListener('popstate', () => this.navigate(window.location.href, true));

      // Cerrar el sheet de filtros con gesto: arrastrar hacia abajo desde el encabezado.
      this.setupSheetDrag();
    }

    setupSheetDrag() {
      var panel = this.querySelector('.kcol__sheet-panel');
      var zone = this.querySelector('.kcol__sheet-head');
      if (!panel || !zone) return;
      var self = this, startY = 0, curY = 0, dragging = false;
      zone.addEventListener('touchstart', function (e) {
        if (window.innerWidth >= 750) return; // solo bottom-sheet móvil
        startY = curY = e.touches[0].clientY; dragging = true;
        panel.style.transition = 'none';
      }, { passive: true });
      zone.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        curY = e.touches[0].clientY;
        var d = curY - startY; if (d < 0) d = 0;
        panel.style.transform = 'translateY(' + d + 'px)';
      }, { passive: true });
      var end = function () {
        if (!dragging) return; dragging = false;
        var d = curY - startY;
        panel.style.transition = '';
        panel.style.transform = '';
        if (d > 80) self.closeSheet();
      };
      zone.addEventListener('touchend', end);
      zone.addEventListener('touchcancel', end);
    }

    openSheet(mode) {
      this.classList.remove('kcol--mode-sort', 'kcol--mode-filter');
      if (mode === 'sort') this.classList.add('kcol--mode-sort');
      else if (mode === 'filter') this.classList.add('kcol--mode-filter');
      this.classList.add('kcol--sheet-open');
      document.body.style.overflow = 'hidden';
      var x = this.querySelector('[data-kcol-close]');
      if (x) x.focus();
    }
    closeSheet() {
      this.classList.remove('kcol--sheet-open');
      document.body.style.overflow = '';
    }

    async navigate(url, fromPop) {
      if (this._busy) return;
      this._busy = true;
      if (this.results) this.results.classList.add('is-loading');
      try {
        var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + this.sectionId;
        var res = await fetch(fetchUrl);
        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        this.swap(doc, '#kcolResults');
        this.swap(doc, '#kcolFilters');
        this.swap(doc, '#kcolFCount');
        this.swap(doc, '#kcolApply');
        this.swap(doc, '#kcolTotal');
        this.swap(doc, '#kcolSortLabel');
        this.results = this.querySelector('#kcolResults');
        if (!fromPop) history.pushState({}, '', url);
        var top = this.querySelector('.kcol__toolbar');
        if (top && !this.classList.contains('kcol--sheet-open')) {
          var y = top.getBoundingClientRect().top + window.pageYOffset - 80;
          if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });
        }
      } catch (err) {
        window.location.href = url;
      } finally {
        if (this.results) this.results.classList.remove('is-loading');
        this._busy = false;
      }
    }

    swap(doc, sel) {
      var next = doc.querySelector(sel);
      var cur = this.querySelector(sel);
      if (next && cur) cur.innerHTML = next.innerHTML;
    }

    async loadMore(link) {
      if (this._busy) return;
      this._busy = true;
      link.classList.add('is-loading');
      try {
        var url = link.getAttribute('href');
        var res = await fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + this.sectionId);
        var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        var grid = this.querySelector('#kcolGrid');
        if (!grid) { window.location.href = url; return; }
        var newCards = doc.querySelectorAll('#kcolGrid > .kcard');
        Array.prototype.forEach.call(newCards, function (c) { grid.appendChild(c); });
        // Reemplaza la barra/botón "cargar más" por el nuevo estado
        var lmNew = doc.querySelector('#kcolLoadmore');
        var lmCur = this.querySelector('#kcolLoadmore');
        if (lmNew && lmCur) lmCur.innerHTML = lmNew.innerHTML;
        history.replaceState({}, '', url);
      } catch (err) {
        window.location.href = link.getAttribute('href');
      } finally {
        this._busy = false;
      }
    }

    async quickAdd(btn) {
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      var drawer = document.querySelector('cart-drawer');
      var sections = (drawer && drawer.getSectionsToRender) ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.kqa, quantity: 1, sections: sections, sections_url: window.location.pathname })
        });
        var json = await res.json();
        if (json.status) { window.location.href = btn.dataset.url || root + 'cart'; return; }
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1400);
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(json);
        } else {
          // Sin cart-drawer: no dejar el add en silencio, ir al carrito
          window.location.href = root + 'cart';
        }
      } catch (err) {
        window.location.href = btn.dataset.url || root + 'cart';
      } finally {
        btn.classList.remove('is-loading');
      }
    }
  }

  if (!customElements.get('klout-facets')) customElements.define('klout-facets', KloutFacets);

  /* ---- Modal "Avísame" (back in stock vía Klaviyo) ---- */
  class KloutNotify extends HTMLElement {
    connectedCallback() {
      this.company = (this.dataset.company || '').trim();
      var self = this;
      this.querySelectorAll('[data-knotify-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(); });
      });
      this._esc = function (e) { if (e.key === 'Escape') self.close(); };
      this.form = this.querySelector('[data-knotify-form]');
      if (this.form) this.form.addEventListener('submit', function (e) { self.submit(e); });
    }
    _show(sel, on) { var el = this.querySelector(sel); if (el) el.hidden = !on; }
    open(variant, title) {
      this.variant = variant;
      var p = this.querySelector('[data-knotify-prod]');
      if (p) p.textContent = title || 'este producto';
      var hasKey = !!this.company && !!variant;
      this._show('[data-knotify-ok]', false);
      this._show('[data-knotify-err]', false);
      this._show('[data-knotify-form]', hasKey);
      this._show('[data-knotify-consent]', hasKey);
      this._show('[data-knotify-soon]', !hasKey);
      if (this.form) this.form.reset();
      this.hidden = false;
      var self = this;
      requestAnimationFrame(function () { self.classList.add('is-open'); });
      document.addEventListener('keydown', this._esc);
      document.body.style.overflow = 'hidden';
      if (hasKey) { var f = this.querySelector('.knotify__field'); if (f) setTimeout(function () { f.focus(); }, 60); }
    }
    close() {
      this.classList.remove('is-open');
      document.removeEventListener('keydown', this._esc);
      document.body.style.overflow = '';
      var self = this;
      setTimeout(function () { self.hidden = true; }, 300);
    }
    async submit(e) {
      e.preventDefault();
      if (!this.company || !this.variant) return;
      var email = this.querySelector('.knotify__field').value;
      var btn = this.querySelector('.knotify__cta');
      btn.disabled = true; btn.classList.add('is-loading');
      try {
        var res = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(this.company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-04-15' },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
              relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + this.variant } } }
            }
          })
        });
        if (res.status === 202 || res.ok) {
          this._show('[data-knotify-form]', false);
          this._show('[data-knotify-consent]', false);
          this._show('[data-knotify-ok]', true);
        } else {
          this._show('[data-knotify-err]', true);
        }
      } catch (err) {
        this._show('[data-knotify-err]', true);
      } finally {
        btn.disabled = false; btn.classList.remove('is-loading');
      }
    }
  }
  if (!customElements.get('klout-notify')) customElements.define('klout-notify', KloutNotify);

  /* ---- Carrito reservado: cuenta regresiva real (persiste entre sesiones) ----
     - La fecha límite se guarda en localStorage la PRIMERA vez y NO se reinicia.
     - Si la persona se va y vuelve: continúa donde iba, o muestra el mensaje de
       expiración si ya pasó. Al expirar muestra un nudge de conversión. ---- */
  class KloutReserve extends HTMLElement {
    connectedCallback() {
      this.clock = this.querySelector('[data-reserve-clock]');
      this.activeEl = this.querySelector('[data-reserve-active]');
      this.expiredEl = this.querySelector('[data-reserve-expired]');
      this.windowMs = (parseInt(this.dataset.seconds, 10) || 300) * 1000;
      var until = 0;
      try { until = parseInt(localStorage.getItem('klout_reserve_until'), 10) || 0; } catch (e) {}
      if (!until) { until = Date.now() + this.windowMs; this._save(until); }
      this.until = until;
      var self = this;
      this.tick();
      this._iv = setInterval(function () { self.tick(); }, 1000);
    }
    _save(v) { try { localStorage.setItem('klout_reserve_until', v); } catch (e) {} }
    expire() {
      this.classList.add('is-expired');
      if (this.activeEl) this.activeEl.hidden = true;
      if (this.expiredEl) this.expiredEl.hidden = false;
      if (this._iv) { clearInterval(this._iv); this._iv = null; }
    }
    tick() {
      var ms = this.until - Date.now();
      if (ms <= 0) { this.expire(); return; }
      var s = Math.floor(ms / 1000);
      var m = Math.floor(s / 60);
      var ss = s % 60;
      if (this.clock) this.clock.textContent = (m < 10 ? '0' : '') + m + ':' + (ss < 10 ? '0' : '') + ss;
    }
    disconnectedCallback() { if (this._iv) clearInterval(this._iv); }
  }
  if (!customElements.get('klout-reserve')) customElements.define('klout-reserve', KloutReserve);

  // Carrito vacío -> reinicia la reserva (nueva intención de compra)
  class KloutReserveReset extends HTMLElement {
    connectedCallback() { try { localStorage.removeItem('klout_reserve_until'); } catch (e) {} }
  }
  if (!customElements.get('klout-reserve-reset')) customElements.define('klout-reserve-reset', KloutReserveReset);

  // Abrir el modal desde cualquier botón "Avísame" (catálogo, PDP, etc.)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-knotify]');
    if (!b) return;
    e.preventDefault();
    var modal = document.querySelector('klout-notify');
    if (modal && typeof modal.open === 'function') modal.open(b.dataset.variant, b.dataset.title);
  });

  // Añadir al carrito de 1 toque (upsell / mejores vendidos del carrito vacío)
  document.addEventListener('click', async function (e) {
    var b = e.target.closest('[data-kcart-add]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-loading')) return;
    b.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var sections = (drawer && drawer.getSectionsToRender) ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: b.dataset.kcartAdd, quantity: 1, sections: sections, sections_url: window.location.pathname })
      });
      var json = await res.json();
      if (!json.status && drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(json);
        if (typeof drawer.open === 'function') drawer.open();
      }
    } catch (err) { /* silencioso: el carrito no cambió */ }
    finally { b.classList.remove('is-loading'); }
  });

  // Copiar guía de seguimiento (página de pedido)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-korder-copy]');
    if (!b) return;
    e.preventDefault();
    var val = b.dataset.korderCopy || '';
    var done = function () { var t = b.textContent; b.textContent = '¡Copiado!'; b.classList.add('is-copied'); setTimeout(function () { b.textContent = t; b.classList.remove('is-copied'); }, 1600); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(val).then(done).catch(function () { done(); });
    } else {
      var ta = document.createElement('textarea'); ta.value = val; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(ta); done();
    }
  });

  // Código de descuento discreto -> aplica vía /discount/CODE y va al checkout
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kcart-discount]');
    if (!b) return;
    e.preventDefault();
    var input = document.getElementById(b.dataset.kcartDiscount);
    var code = input && input.value ? input.value.trim() : '';
    if (!code) { if (input) input.focus(); return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  });
})();
